import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';

export interface IUploadProps {
  activeClassName?: string;
}

export const Upload = Styled.div<IUploadProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 12em;
  background: ${({ theme: { upload } }) => upload.colorBackground};
  border: ${({ theme: { upload } }) => `${upload.borderWidth} ${upload.borderStyle} ${upload.colorBorder}`};

  ${({ theme: { upload }}) => upload.width && css`
    width: ${upload.width};
  `}

  ${({ theme: { upload }, activeClassName }) => css`
    .${activeClassName} & {
      background: ${upload.colorActiveBackground};
      border: ${upload.borderWidth} ${upload.borderStyle} ${upload.colorActiveBorder};
    }
  `}

  * {
    text-align: center;

    &:not(button, a, button > *) {
      color: ${({ theme: { upload } }) => upload.colorText};
    }

    &:not(:empty):last-child {
      margin-bottom: 0;
    }
  }

  ${({ theme: { upload }}) => media.medium`
    min-height: ${upload.size};
    padding: 2em;
  `}
`;

Upload.defaultProps = {
  activeClassName: 'uploadActive'
};

Upload.displayName = 'Upload';

export const UploadTap = Styled.div`
  padding: 1.5em 1em;
  display: block;
  position: relative;

  ${media.medium`
    display: none;
  `}
`;

UploadTap.displayName = 'UploadTap';

export const UploadTapLabel = Styled.span`
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;

  /* hide file input */
  opacity: 0;
`;

UploadTapLabel.displayName = 'UploadTapLabel';

export const UploadTapImg = Styled.div`
  margin-bottom: 0.5em;
`;
UploadTapImg.displayName = 'UploadTapImg';

export const UploadBrowse = Styled.div`
  display: none;

  ${media.medium`
    display: block;
  `}
`;

export const UploadBrowseImg = Styled.div`
  margin-bottom: 1.5em;
`;
UploadBrowseImg.displayName = 'UploadBrowseImg';

export const UploadCta = Styled.div`
  margin: 1.5em 0;
`;

UploadCta.displayName = 'UploadCta';
